import React from 'react';
import moment from 'moment';
import 'moment/locale/pt-br';
import { BlogPostHeader } from '../../models/BlogPostHeader';
import  { Link } from 'react-router-dom';
import { useParameters } from '../../utils';
import { prepareCategories, blogUrl, PostCollections, blogCategoryUrl } from './utils';
import { NamedObject } from '../../models/NamedObject';
import { HtmlContent } from '../../models/HtmlContent';

export interface DisplayArticle {
    id: number,
    categories?: NamedObject[]
    jetpack_featured_media_url?: string,
    modified?: string;
    date: string;
    slug?: string;
    title?: HtmlContent;
    excerpt?: HtmlContent;
    type?: string;
    languages?: Array<{ id: number, languageCode: string, slug: string }>;
}
export function DisplayArticle(p: { post: DisplayArticle, collection: PostCollections}) {
    const routeParam = useParameters<{
        lang: string,
    }>();
    const collection = (p.post.type ?? p.collection) as PostCollections ;
    const postUrl = blogUrl(routeParam.lang, p.post, collection);
    const { displayCategories } = prepareCategories(p.post.categories, true);
    return <div className='article-container'>
        <div className='article-image-container'>
            <Link to={postUrl} >
                <div className='article-image' style={{ backgroundImage: `url(${p.post.jetpack_featured_media_url})` }}></div>
            </Link>
        </div>
        <div className='article-text-container article-text-props'>
            <div><Link to={postUrl}><p dangerouslySetInnerHTML={{ __html: p.post.title?.rendered! }} className='article-title'></p></Link></div>
            <div>
                <Link to={postUrl} >
                    <p dangerouslySetInnerHTML={{ __html: p.post.excerpt?.rendered! }} className='article-description' />
                </Link>
            </div>
            <div><p className='article-date'>{moment(p.post.modified ?? p.post.date).locale(routeParam.lang ?? 'en').format("MMM D YYYY")}</p></div>
            {displayCategories &&
                <div className='article-tags'>
                    {displayCategories.map((c) =>
                        <Link key={c.id} className='tag-link' to={blogCategoryUrl(routeParam.lang, c.slug, p.collection)}
                            dangerouslySetInnerHTML={{ __html: c.name }}></Link>
                    )}
                </div>}
        </div>
    </div>
}